import { gql } from '@efficiently/client-core-graphql-models';

export const GET_DOWNLOAD_CONTENT_URL = gql(`
	mutation GetDownloadContentUrl($args: GetDownloadContentUrlArgs!) {
		getDownloadContentUrl(args: $args)
	}
`);
